<template>
<div>
  <main-view :nowScroll="nowScroll"></main-view>
  <videos :nowScroll="nowScroll"></videos>
  <Satellites :nowScroll="nowScroll"></Satellites>
  <ground-station :nowScroll="nowScroll"></ground-station>
  <satellite-imagery :nowScroll="nowScroll"></satellite-imagery>
  <Footer></Footer>
</div>
</template>

<script>
import $ from "jquery"
import MainView from "@/components/home/MainView";
import Videos from "@/components/home/Video";
import Satellites from "@/components/home/Satellites";
import Footer from "@/components/home/Footer"
import GroundStation from "@/components/home/GroundStation";
import SatelliteImagery from "@/components/home/SatelliteImagery";


export default {
  name: "Home",
  components: {SatelliteImagery, GroundStation, MainView, Videos, Satellites, Footer},
  data: ()=> ({
    nowScroll: null,
  }),
  mounted() {
    addEventListener('scroll', this.scrollEvent)
  },
  methods: {
    scrollEvent() {
      this.nowScroll = $('html').scrollTop()
    }
  },
  beforeDestroy() {
    removeEventListener('scroll', this.scrollEvent)
  }

}
</script>

<style scoped>

</style>